import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  float: left;
  width: 100%;

  & .MuiTabs-root {
    margin-bottom: 10px;
  }
`

export const Wrapper = styled.div`
  align-items: baseline;
  display: flex;
`

export const Dates = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`
